<div>
  <!-- Error Message -->
  <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
    <i class="bi bi-exclamation-triangle-fill me-2"></i>
    {{ errorMessage }}
    <button type="button" class="btn-close" aria-label="Close" (click)="errorMessage = ''" aria-label="Close"></button>
  </div>

  <!-- Success Message -->
  <div *ngIf="successMessage" class="alert alert-success alert-dismissible fade show" role="alert">
    <i class="bi bi-check-circle-fill me-2"></i>
    {{ successMessage }}
    <button type="button" class="btn-close" aria-label="Close" (click)="successMessage = ''" aria-label="Close"></button>
  </div>

  <!-- Header -->
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h5 class="mb-0">
      <i class="bi bi-calendar-range me-2"></i>
      Spray Seasons
    </h5>
    <button class="btn btn-primary btn-sm" (click)="toggleAddForm()">
      <i class="bi" [class.bi-plus]="!showAddForm" [class.bi-x]="showAddForm"></i>
      {{ showAddForm ? 'Cancel' : 'Add Season' }}
    </button>
  </div>

  <!-- Add Season Form -->
  <div *ngIf="showAddForm" class="card border-0 bg-transparent shadow-none mb-3">
    <div class="card-body">
      <h6 class="mb-3">New Season</h6>
      <div *ngIf="addingSeasonError" class="alert alert-danger py-2 mb-3">
        {{ addingSeasonError }}
      </div>
      <!-- Overlap Warning (soft warning, does not prevent saving) -->
      <div *ngIf="overlapWarning" class="alert alert-warning py-2 mb-3" role="alert">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>
        {{ overlapWarning }}
      </div>
      <div class="row g-3">
        <div class="col-md-4">
          <label class="form-label">Label</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="newSeason.label"
            placeholder="e.g., 2026 Season"
          />
        </div>
        <div class="col-md-4">
          <label class="form-label">Start Date</label>
          <input
            type="date"
            class="form-control"
            [(ngModel)]="newSeason.startDate"
            (ngModelChange)="checkSeasonOverlap()"
          />
        </div>
        <div class="col-md-4">
          <label class="form-label">End Date</label>
          <input
            type="date"
            class="form-control"
            [(ngModel)]="newSeason.endDate"
            (ngModelChange)="checkSeasonOverlap()"
          />
        </div>
      </div>
      <div class="mt-3">
        <button
          class="btn btn-primary btn-sm"
          (click)="submitSeason()"
          [disabled]="addingSeason"
        >
          <span *ngIf="addingSeason" class="spinner-border spinner-border-sm me-1" role="status"></span>
          {{ addingSeason ? 'Creating...' : 'Create Season' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-4">
    <div class="spinner-border spinner-border-sm text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && seasons.length === 0" class="text-center py-5 text-muted">
    <i class="bi bi-calendar-range fs-1 d-block mb-3"></i>
    <p>No seasons configured for this organization.</p>
    <p class="small">Seasons define the date range for Acre Advantage point calculations.</p>
  </div>

  <!-- Seasons Table -->
  <div class="table-responsive" *ngIf="!loading && seasons.length > 0">
    <table class="table table-hover mb-0">
      <thead>
        <tr>
          <th>Label</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let season of seasons">
          <td class="fw-medium">{{ season.label }}</td>
          <td>{{ formatDate(season.startDate) }}</td>
          <td>{{ formatDate(season.endDate) }}</td>
          <td>
            <span class="badge" [ngClass]="getStatusBadgeClass(getSeasonStatus(season))">
              {{ getSeasonStatus(season) }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
